import React, { useContext, useMemo } from 'react';

import StaffNameWithProfile from '@/components/StaffNameWithProfile';
import AppContext from '@/contexts/appContext';
import PersonContext from '@/pages/Person/PersonContext';
import type { Staff } from '@/types/person';
import type PersonStaffRelationship from '@/types/personStaffRelationship';
import { Typography } from '@/ui';

const PersonCareTeam = () => {
  const { person } = useContext(PersonContext);
  const { currentUser } = useContext(AppContext);

  const staffRelationships = useMemo(
    () =>
      [...(person?.staff_relationships ?? [])]
        .filter(
          (relationship): relationship is PersonStaffRelationship & { staff: Staff } =>
            !!relationship.staff
        )
        .sort(
          (a, b) =>
            (a.relationship_type?.display_order ?? 0) - (b.relationship_type?.display_order ?? 0)
        ),
    [person?.staff_relationships]
  );

  return (
    <>
      {!staffRelationships.length ? (
        <Typography className="mt-2" muted>
          No care team members.
        </Typography>
      ) : (
        <dl className="mt-2 space-y-0.5">
          {staffRelationships.map((relationship) => (
            <div
              className="grid grid-cols-[minmax(0,10rem)_1fr] items-baseline gap-2"
              key={relationship.id}>
              <Typography as="dt" muted>
                {relationship.relationship_type?.name}
              </Typography>

              <Typography as="dd" weight="bold">
                <StaffNameWithProfile staff={relationship.staff} />
                {relationship.staff.id === currentUser?.staff_id && ' (you)'}
              </Typography>
            </div>
          ))}
        </dl>
      )}
    </>
  );
};

export default React.memo(PersonCareTeam);
